import { ConstantPool } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

@Component({
  selector: 'app-leave-report',
  templateUrl: './leave-report.component.html',
  styleUrls: ['./leave-report.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, MatPaginatorModule],
})
export class LeaveReportComponent implements OnInit {
  arrCount = [];
  showFirstName: any;
  showLastName: any;
  totalLeaveOneUser: any;
  totalAbsentOneUser = 0;
  totalPaidLeaves = 0;
  totalUnpaidLeaves = 0;
  apidata: any;
  apiGetName: any;
  public showSpinner = true;
  arr: any = [];
  isCurrentYearVisible = true;
  isLastYearVisible = false;
  _last_year_data: any;
  searchName = '';
  apisecond: any[] = [];
  userData: any;
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  pagedData: any[] = [];
  pageSize = 50;
  currentPage = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  refresh: any;
  constructor(
    private leaveService: LeaveService,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {

    this.isleaveReport();
    this.user_refresh();
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user
      this.user = this.refresh;

      const user_role = JSON.parse(this.user.user_role.user_roles)
      if (user_role.role_type == "Employee") {
        this.router.navigate(['/dashboard-1']);
      }
    })

  }
  isResetLeavePermission(): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);

    if (user_role.role_type === "Employee" || user_role.role_type === "Team_Lead") {
      return false;
    }

    return user_role?.leave_data?.data?.values?.reset_leave ?? false;
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  showCurrentYearData() {

    this._last_year_data = null;
    this.isleaveReport();

    this.isCurrentYearVisible = true;
    this.isLastYearVisible = false;

  }
  showLastYearData() {
    this._last_year_data = true;

    this.isleaveReport();
    this.isCurrentYearVisible = false;
    this.isLastYearVisible = true;

  }
  searchDataFun() {

    this.isleaveReport();
    this.searchName = '';
  }

  isleaveReport() {
    const last_year_data = this._last_year_data;
    const name = this.searchName;
    this.leaveService.leaveReportFunction(last_year_data, name).then((value) => {
      this.showSpinner = true;
      this.apidata = value?.data;
      this.apisecond = []
      const otherOffDays: string[] = [];
      this.apidata.holidayData.forEach((element: { date: string; day_name: string; }) => {
        otherOffDays.push(element.date)
      });
      for (let j = 0; j <= this.apidata.LeaveData.length - 1; j++) {
        this.showSpinner = true;

        const loopSingleObject = this.apidata.LeaveData[j]
        const oneUserData: any = {};
        if (loopSingleObject.first_name !== null && loopSingleObject.first_name !== undefined && loopSingleObject.last_name !== null && loopSingleObject.last_name !== undefined) {
          oneUserData["name"] = loopSingleObject.first_name + " " + loopSingleObject.last_name;
        } else {
          oneUserData["name"] = "No Name";
        }
        if (loopSingleObject.total_leaves !== null && loopSingleObject.total_leaves !== undefined) {
          oneUserData["total_leaves"] = parseFloat(loopSingleObject.total_leaves);
        } else {
          oneUserData["total_leaves"] = 0;
        }
        if (loopSingleObject.old_total_leaves !== null && loopSingleObject.old_total_leaves !== undefined) {
          oneUserData["old_total_leaves"] = parseFloat(loopSingleObject.old_total_leaves);
          const parsedValue = parseFloat(loopSingleObject.old_total_leaves);
          oneUserData["old_total_leaves"] = isNaN(parsedValue) ? 0 : parsedValue;
        } else {
          oneUserData["old_total_leaves"] = 0;
        }
        if (loopSingleObject.old_leaves !== null && loopSingleObject.old_leaves !== undefined) {
          oneUserData["old_leaves"] = parseFloat(loopSingleObject.old_leaves);
        } else {
          oneUserData["old_leaves"] = 0;
        }
        let totalPaidLeave = 0;
        let totalUnpaidLeave = 0;

        for (let i = 0; i <= loopSingleObject.leaves.length - 1; i++) {
          var oneUserAllLeaves = loopSingleObject.leaves[i];
          if (oneUserAllLeaves !== undefined) {
            if (oneUserAllLeaves?.status === "approved" && oneUserAllLeaves.leave_payment_status === "paid" && oneUserAllLeaves?.leave_payment_status !== null) {
              if (oneUserAllLeaves.leave_type_id == 2) {
                const leave_startdate = oneUserAllLeaves?.start_date;
                const leave_enddate = oneUserAllLeaves?.end_date;
                const start = new Date(leave_startdate);
                start.setDate(start.getDate() - 1); // This modifies the start date in place by minus one
                const end = new Date(leave_enddate);
                const diffTime = Math.abs(end.getTime() - start.getTime());
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                totalPaidLeave += diffDays
              } else {
                if (oneUserAllLeaves.shortLeave_hours && !isNaN(oneUserAllLeaves.shortLeave_hours)) {
                  // Calculate the proportion of short leave hours against total working hours (8 hours)
                  const shortLeaveFraction = Math.round((oneUserAllLeaves.shortLeave_hours / 8) * 100) / 100;
                  totalPaidLeave += shortLeaveFraction;
                } else {
                  totalPaidLeave += 0.5

                }
              }
            } else if (oneUserAllLeaves.leave_payment_status === "unpaid" && oneUserAllLeaves.status === "approved" && oneUserAllLeaves.leave_payment_status !== undefined && oneUserAllLeaves.leave_payment_status !== null) {
              if (oneUserAllLeaves.leave_type_id == 2) {
                const leave_startdate = oneUserAllLeaves?.start_date;
                const leave_enddate = oneUserAllLeaves?.end_date;
                const start = new Date(leave_startdate);
                start.setDate(start.getDate() - 1); // This modifies the start date in place by minus one
                const end = new Date(leave_enddate);
                const diffTime = Math.abs(end.getTime() - start.getTime());
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                totalUnpaidLeave += diffDays
              } else {
                if (oneUserAllLeaves.shortLeave_hours && !isNaN(oneUserAllLeaves.shortLeave_hours)) {
                  // Calculate the proportion of short leave hours against total working hours (8 hours)
                  const shortLeaveFraction = Math.round((oneUserAllLeaves.shortLeave_hours / 8) * 100) / 100;
                  totalUnpaidLeave += shortLeaveFraction;
                } else {
                  totalUnpaidLeave += 0.5

                }

              }

            }
            else {
              // console.error('leave_payment_status is undefined at index ' + i);
            }
          }
        }
        if (totalPaidLeave !== null && totalPaidLeave !== undefined) {
          oneUserData["paid_leaves"] = totalPaidLeave;
        } else {
          oneUserData["paid_leaves"] = 0;
        }
        if (totalUnpaidLeave !== null && totalUnpaidLeave !== undefined) {
          oneUserData["unpaid_leaves"] = totalUnpaidLeave;
        } else {
          oneUserData["unpaid_leaves"] = 0;
        }

        // end paid leaves and unpaid leave count for one user


        // start absent count from attendance=null
        let absent = 0;
        for (let i = 0; i <= loopSingleObject.attendance.length - 1; i++) {
          var oneUserAllLeaves = loopSingleObject.attendance[i];
          if (oneUserAllLeaves !== undefined) {
            if (oneUserAllLeaves.check_in === null && oneUserAllLeaves.check_out === null) {
              const dateOBJ = new Date(oneUserAllLeaves.date);
              if (dateOBJ.getDay() != 0 && dateOBJ.getDay() != 6 && !otherOffDays.includes(oneUserAllLeaves.date)) {
                absent = absent + 1;
              }

            }
            else {
              // console.error('this.apiGetName.attendance[i].check_in or chekout !== null is undefined at index ' + i);
            }
          }


        }
        if (absent !== null && absent !== undefined) {
          oneUserData["absent"] = absent
        } else {
          oneUserData["absent"] = 0;
        }
        this.apisecond.push(oneUserData)
        this.updatePagedData();

      }

      this.showSpinner = false;

    })

  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updatePagedData();
  }

  // Method to update the paged data
  updatePagedData() {
    this.showSpinner = true;

    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.pagedData = this.apisecond.slice(startIndex, endIndex);
    this.showSpinner = false;


  }

  resetLeaves() {
    this.showSpinner = true;
    this.leaveService.leavesReset().then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Leave Reset Successfully',
          showConfirmButton: false,
          timer: 3000,
        });

        window.location.reload();
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }


    })
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
    })

  }
}
